import React, { useState } from 'react';
import countries from 'country-list';
import estados_mex from "./estados_mex.json";
import { postScammer } from '../requests/postScammer';
import { useTranslation } from 'react-i18next';

// Form Component to Collect Scammer Information
export const ScammerForm = ({ onSubmit }) => {

  const [selectedState, setSelectedState] = useState('');
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    firstNameScammer: '',
    lastNameScammer: '',
    amountInvested: '',
    amountWithdrawn: '',
    country: '',
    dateOfRegistry: '',
    comment: '',
    scamCompany: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'amountInvested' || name === 'amountWithdrawn') {
      setFormData({ ...formData, [name]: value + '.00' });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Reset selectedState if country is not Mexico
    if (name === 'country' && value !== 'Mexico') {
      setSelectedState('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firstNameScammer || !formData.lastNameScammer || !formData.amountInvested ||
      !formData.amountWithdrawn || !formData.country ||
      !formData.dateOfRegistry || !formData.scamCompany) {
      alert(t('alert01'));
      return;
    }

    // Confirmation dialog
    const isConfirmed = window.confirm(t('alert02'));

    if (isConfirmed) {
      const finalData = {
        ...formData,
        mexState: formData.country === 'Mexico' ? selectedState : '',
      };
      await postScammer(finalData); // Send the data to the backend
      onSubmit(); // Close the modal

      // Reset the form after submission
      setFormData({
        firstNameScammer: '',
        lastNameScammer: '',
        amountInvested: '',
        amountWithdrawn: '',
        country: '',
        dateOfRegistry: '',
        comment: '',
        scamCompany: ''
      });
      setSelectedState(''); // Reset the selected state for Mexico
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('associatedScamCompany')} *</label>
        <select
          name="scamCompany"
          value={formData.scamCompany}
          onChange={handleChange}
          className="w-full p-2 border rounded bg-yellow-100"
          required
        >
          <option value="">{t('selectPonziCompany')}</option>
          <option value="SmartPlus">SmartPlus</option>
          <option value="Cryptosafe">Cryptosafe</option>
          <option value="Cutomex">Cutomex</option>
          <option value="TruCapitals">TruCapitals</option>
          <option value="Inverforx">Inverforx</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('scammerFirstName')} *</label>
        <input
          type="text"
          name="firstNameScammer"
          placeholder={t('scammerFirstNamePlaceholder')}
          value={formData.firstNameScammer}
          onChange={handleChange}
          className="w-full p-2 border rounded bg-yellow-100"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('scammerLastName')} *</label>
        <input
          type="text"
          name="lastNameScammer"
          placeholder={t('scammerLastNamePlaceholder')}
          value={formData.lastNameScammer}
          onChange={handleChange}
          className="w-full p-2 border rounded bg-yellow-100"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('amountInvested')} *</label>
        <div className="flex items-center">
          <input
            type="text"
            name="amountInvested"
            maxLength={7}
            placeholder={t('amountInvestedPlaceholder')}
            value={formData.amountInvested.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, '');
              setFormData({ ...formData, amountInvested: value });
            }}
            className="w-250 p-2 border rounded text-right"
            required
          />
          <span className="ml-2 p-2 bg-gray-200 rounded">.00</span>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('amountWithdrawn')} *</label>
        <div className="flex items-center">
          <input
            type="text"
            name="amountWithdrawn"
            maxLength={7}
            placeholder={t('amountWithdrawnPlaceholder')}
            value={formData.amountWithdrawn.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, '');
              setFormData({ ...formData, amountWithdrawn: value });
            }}
            className="w-250 p-2 border rounded text-right"
            required
          />
          <span className="ml-2 p-2 bg-gray-200 rounded">.00</span>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('country')} *</label>
        <select
          name="country"
          value={formData.country}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        >
          <option value="">{t('selectCountry')}</option>
          <option key={'MX'} value={'Mexico'}>Mexico</option>
          <option value="United States of America">United States of America</option>
          {countries.getData().map((country) => (
            <option key={country.code} value={country.name}>
              {country.name}
            </option>
          ))}
        </select>
      </div>

      {formData.country === 'Mexico' && (
        <div>
          <label className="block text-sm font-medium text-gray-700">{t('stateInMexico')} *</label>
          <select
            name="mexState"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            className="w-full p-2 border rounded"
            required
          >
            <option value="">{t('selectState')}</option>
            {estados_mex.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700">{t('dateOfRegistry')} *</label>
        <input
          type="date"
          name="dateOfRegistry"
          value={formData.dateOfRegistry}
          onChange={handleChange}
          className="w-250 p-2 border rounded"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('comment')}</label>
        <textarea
          name="comment"
          placeholder={t('commentPlaceholder')}
          value={formData.comment}
          onChange={handleChange}
          className="w-full p-2 border rounded"
        />
      </div>
      <button
        type="submit"
        className="w-full px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
      >
        {t('submit')}
      </button>
    </form>
  );
};